import { render, staticRenderFns } from "./ItemIconTooltip.vue?vue&type=template&id=0636f756&scoped=true&"
import script from "./ItemIconTooltip.vue?vue&type=script&lang=js&"
export * from "./ItemIconTooltip.vue?vue&type=script&lang=js&"
import style0 from "./ItemIconTooltip.vue?vue&type=style&index=0&id=0636f756&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0636f756",
  null
  
)

export default component.exports